import styled, { css } from 'styled-components';

import { FlexDiv, GenericSpan, GenericDiv, Headings } from 'commonStyles';

export const ContentSectionWrap = styled(FlexDiv)`
	top: 0;
`;

export const ContentWrapper = styled(FlexDiv)`
	padding: ${(props) => props.padding ? props.padding : '0'};
`;

export const DescriptionWrapper = styled(FlexDiv)`
	padding: ${(props) => props.padd ? props.padd : '0'};
	text-align: left;
`;

export const Description = styled(FlexDiv)`
	line-height:${(props) => props.line_height ? props.line_height : '24px'};
`;

export const ListingWrapper = styled(GenericDiv)`
	:first-child {
    margin-top: 0px;
	}

	:last-child {
    margin-bottom: 0px;
	}
`;

export const BulletStyle = styled(GenericSpan)`
	width: 4px;
	height: 4px;
	background-color: ${(props) => props.color ? props.color : '#FF664B'};
	border-radius: 50%;
`;

export const NumberBullet = styled(FlexDiv)`
	content: '';
	align-self: flex-start;
	flex-shrink: 0;
	line-height: 16px;
`;

export const ListHead = styled(GenericSpan)`
	width: 98%;
`;

export const ContentHeading = styled(Headings)`
	margin:${(p)=>(p.margin || '0')};
	width: ${(p)=> p.$width || '100%'};
`;

export const ContentTypeWrap = styled(FlexDiv)`
top:${(p)=>(p.$top || '0')};
	${(props) => {
		switch (props.boxType) {
			case 'grey':
				return css`
					background: #F9F9F9;
					border: 1px solid #D8D8D8;
					border-radius: 8px;`;
			default:
				return css`
					background: ${props.$bg};
					border: 1px solid ${props.bdrColor || 'transparent'};
					border-radius: 8px;`;
		}
	}}
`;
